import { type ContentTableItem } from "src/components/ContentTable/ContentTable";

export const mapAreasToContentTableItems = (
	areas: Area[]
): ContentTableItem[] => {
	return areas.map((area) => ({
		id: area.id,
		name: area.name,
		isActive: true,
		lastUpdated: area.updatedAt,
		data: {
			region: area.region?.name ?? "—",
			manager: area.areaManager?.name ?? "—",
			lastsync: area.lastsync
		}
	}));
};
